import { DEFAULT_VALUE } from "@supplier/constants";

function isUndefined(value: unknown): value is undefined {
    return value === undefined;
}

function isNil(value: unknown): value is null | undefined {
    return value === null || value === undefined;
}

function get(obj: unknown, path: string, defaultValue?: unknown) {
    if (!path) {
        return isUndefined(obj) ? defaultValue : obj;
    }

    const keys = path
        .replace(/\[(\w+)\]/g, ".$1")
        .split(".")
        .filter(Boolean);

    let result: unknown = obj;

    for (const key of keys) {
        if (isNil(result)) {
            return defaultValue;
        }
        result = (result as Record<string, unknown>)[key];
    }

    return isUndefined(result) ? defaultValue : result;
}

/**
 * 将对象转化为formData
 * @param obj
 * @param checkVoid
 */
export function convertObjectToFormData(obj: unknown, checkVoid?: boolean): FormData {
    const formData = new FormData();
    const checkedVoid = checkVoid || false;

    if (!obj || typeof obj !== "object") {
        return formData;
    }

    for (const key of Object.keys(obj)) {
        const value = (obj as Record<string, unknown>)[key];

        if (!checkedVoid) {
            if (value !== undefined && value !== null && value !== "" && (!Array.isArray(value) || value.length !== 0)) {
                if (Array.isArray(value)) {
                    value.forEach(item => {
                        formData.append(key, String(item));
                    });
                } else {
                    formData.append(key, String(value));
                }
            }
        } else if (value !== undefined && value !== "") {
            if (Array.isArray(value)) {
                value.forEach(item => {
                    formData.append(key, String(item));
                });
            } else {
                formData.append(key, String(value));
            }
        }
    }

    return formData;
}

// 获取属性值
export function getValueByProp(data: unknown, prop: string, defaultValue?: unknown) {
    const defaultText = isUndefined(defaultValue) ? DEFAULT_VALUE : defaultValue;
    const value = get(data, prop);
    return isNil(value) || value === "" ? defaultText : value;
}

export function getDefaultValue(value: unknown, defaultValue: unknown = DEFAULT_VALUE) {
    return isNil(value) ? defaultValue : value;
}
